import superagent from 'superagent';
import getCookie from './getCookie';

const webserviceAdmin = process.env.REACT_APP_WEBSERVICE_ADMIN_CARTMX;

export default async function postAdminCarritoMX({ tmbservice, jsonBody }) {
  const url = `${webserviceAdmin}/${tmbservice}`;
  let response = {};

  await superagent
    .post(url)
    .send(jsonBody)
    .auth(getCookie('TokenNvoAdminMX'), { type: 'bearer' })
    .then((res) => {
      response = res?.body || {};
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        error: err,
        tipoMensaje: 'error',
        mensaje: 'Error',
      };
      response = resp;
    });

  return response;
}
